import { gql } from '@apollo/client';

export * from './assetsDepositSource.query.generated';

export const ASSETS_DEPOSIT_SOURCE = gql`
  query assetsDepositSource($softwareEscrowId: ID!, $type: AssetTypeEnum, $perPage: Int) {
    assetsSource: assets(
      softwareEscrowId: $softwareEscrowId
      type: $type
      page: 1
      perPage: $perPage
      orderBy: asset_type
      order: asc
    ) {
      nodes {
        id
        externalId
        depositSource
        type
        integration {
          id
        }
      }
    }
  }
`;
